import {Injectable} from '@angular/core';
import {WidgetDetail} from '../../widget/model/widget-detail';
import {WidgetName} from '../../widget/model/widget-name.enum';
import {InviseoVariablesExtraction} from '../model/inviseo-variables-extraction';
import {DomainUrlService} from '../../../application/config/domain-url.service';
import {InviseoScenariosPartages} from '../model/inviseo-scenarios-partages';

@Injectable({
  providedIn: 'root'
})
export class InviseoWidgetUtilService {

  private static readonly GRAPH_TYPE_BY_CODE: Map<string, string> = new Map<string, string>([
    ['EPARGNE_DE_GESTION', 'column'],
    ['FOND_DE_ROULEMENT_FIN_EXERCICE', 'column'],
    ['EPARGNE_NET', 'column'],
    ['TAUX_EPARGNE_BRUT', 'line'],
    ['RATIO_DESENDETTEMENT', 'column'],
    ['SEUIL_LIMITE_RATIO_DESENDETTEMENT', 'line']
  ]);

  private static readonly REDIRECT_BY_WIDGET: Map<WidgetName, string> = new Map<WidgetName, string>([
    [WidgetName.EPARGNE_DE_GESTION, 'depense_de_fonctionnement'],
    [WidgetName.FOND_DE_ROULEMENT_FIN_EXERCICE, 'strategie_sur_le_resultat'],
    [WidgetName.NIVEAU_DES_EPARGNES, 'dette'],
    [WidgetName.RATIO_DE_DESENDETTEMENT, 'dette']
  ]);

  constructor(private domainUrlService: DomainUrlService) {
  }

  getRedirectLink(widgetDetail: WidgetDetail, inviseoVariablesExtraction: InviseoVariablesExtraction): string {
    const inviseoRootUrl = this.domainUrlService.getInviseoUrl();
    let redirectPage;
    if (inviseoVariablesExtraction.context.scenarioType === 'FIL_DE_L_EAU') {
      redirectPage = 'synthese';
    } else {
      redirectPage = InviseoWidgetUtilService.REDIRECT_BY_WIDGET.get(widgetDetail.widgetName);
    }
    const accountId = inviseoVariablesExtraction.context.accountId;
    const scenarioId = inviseoVariablesExtraction.context.scenarioId;

    return `${inviseoRootUrl}?redirectLink=${redirectPage}&accountId=${accountId}&scenarioId=${scenarioId}`;
  }

  getRedirectLinkForSharedScenario(inviseoScenariosPartages: InviseoScenariosPartages): string {
    const inviseoRootUrl = this.domainUrlService.getInviseoUrl();

    const accountId = inviseoScenariosPartages.accountId;
    const scenarioId = inviseoScenariosPartages.idDernierScenarioTravaille;

    return `${inviseoRootUrl}?redirectLink=synthese&accountId=${accountId}&scenarioId=${scenarioId}`;
  }

  getChartTypeForVariableCode(variableCode: string): string {
    return InviseoWidgetUtilService.GRAPH_TYPE_BY_CODE.get(variableCode);
  }

}
